const ViewNotFound = () => {
  return <div>Kunde inte hitta innehållet</div>;
};

export default ViewNotFound;
